<template>
  <div class="dashboard-layout">
    <Sidebar v-model:visible="sidebarVisible">
        <h3>Menu</h3>
        <ul class="p-d-flex p-flex-column p-gap-2">
            <li><router-link to="/dashboard">Dashboard</router-link></li>
            <li><router-link to="/dashboard/books">Books</router-link></li>
        </ul>
    </Sidebar>

    <div class="main-content">
      <Navbar @toggle-sidebar="sidebarVisible = !sidebarVisible" :username="username" />
      <main class="content-body">
        <div class="metrics-bar">
          <span class="metric-item"><i class="pi pi-book metric-icon" title="Libri totali"></i> {{ metrics.total_books }}</span>
          <span class="metric-item"><i class="pi pi-file metric-icon" title="Pagine totali"></i> {{ metrics.total_pages }}</span>
          <span class="metric-item"><i class="pi pi-check-circle metric-icon" title="Pagine elaborate"></i> {{ metrics.processed_pages }}</span>
          <span class="metric-item"><i class="pi pi-cog metric-icon" title="Esecuzioni totali"></i> {{ metrics.total_executions }}</span>
        </div>
        <router-view />
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Sidebar from 'primevue/sidebar';
import Navbar from '../components/Navbar.vue';
import api from '../services/api';

const sidebarVisible = ref(false);
const username = ref('');
const metrics = ref({ total_pages: 0, processed_pages: 0, total_executions: 0, total_books: 0 });

onMounted(async () => {
  username.value = localStorage.getItem('user') || 'Guest';
  try {
    const response = await api.get('/metrics');
    metrics.value = response.data;
  } catch (e) {
    metrics.value = { total_pages: '-', processed_pages: '-', total_executions: '-', total_books: '-' };
  }
});
</script>

<style scoped>
.dashboard-layout {
  display: flex;
  height: 100vh;
}

.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
}

.content-body {
  padding: 1.5rem;
  flex-grow: 1;
  overflow-y: auto;
}

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

ul a {
    text-decoration: none;
    color: var(--text-color);
    display: block;
    padding: 0.5rem 1rem;
    border-radius: 6px;
}

ul a:hover {
    background-color: var(--surface-hover);
}

.metrics-bar {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  font-size: 0.95rem;
  color: #888;
  margin-bottom: 0.5rem;
  padding: 0.25rem 1rem;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}
.metric-item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.98em;
}
.metric-icon {
  font-size: 1.1em;
  color: #b0b0b0;
}
</style>
